import { useState } from "react";
import DynamicTable from "../../../../../utils/Table/DynamicTable";
import RenderActions from "../../CommonComponent/RenderActions";
import ChildTable from "./ChildTable";
import NoSubPages from "./NoSubPage";
import { useSelector } from "react-redux";
import { BASE_URL } from "../../../../../constant/apiUrl";
import { useDispatch } from "react-redux";
import Loading from "../../../../../utils/Loader";
import { handleRowOrderChange } from "./commonfunction";
import { Icon } from "pepsico-ds";
import { useNavigate } from "react-router-dom";

const columns = [
  { id: "actions", label: " ", width: "80px" },
  {
    id: "name",
    label: "PAGE TITLE",
    width: "200px",
  },

  { id: "createdBy", label: "CREATED", width: "200px" },
  { id: "modifiedBy", label: "LAST MODIFIED", width: "200px" },
  { id: "navigationType", label: "TYPE", width: "200px", cellStyle: "cellStyle" },
  { id: "status", label: "STATUS", width: "200px" },
  { id: "secondaryactions", label: " ", width: "80px" },
];

const PageTable = ({ searchText, loading }) => {
  const [expandedRow, setExpandedRow] = useState(null);
  const navigate = useNavigate();
  const renderActions = (row, col) => {
    if (col.id === "secondaryactions" && row?.navigationType === "INTERNAL") {
      return (
        <Icon
          className="$color-icon-default"
          icon={"edit"}
          size="medium"
          style={{ color: "#005cbc" }}
          data-testid="icon"
          onClick={(e) => {
            e.stopPropagation(); // ✅ prevent

            navigate(`/admin/pageBuilder/${row.pageId}`);
          }}
        />
      );
    }
    if (col.id == "actions") {
      return RenderActions(expandedRow);
    }
  };
  const [reload, setReload] = useState(false);
  const { pages } = useSelector((store) => store.pagebuilder);
  const toggleRowExpansion = (rowId) => {
    setExpandedRow((prev) => (prev === rowId ? null : rowId));
  };
  const dispatch = useDispatch();
  const renderChild = (row) => {
    return row?.children?.length > 0 ? (
      <ChildTable row={row} />
    ) : (
      <NoSubPages />
    );
  };

  const handleRowOrder = async (newRows) => {
    const pageIds = newRows.map((item) => item.id);
    const result = { pageIds };

    await handleRowOrderChange(
      `${BASE_URL}/admin/order/pages`,
      result,
      setReload,
      dispatch
    );
  };

  const cellRenderer = (value, row) => {
    if (row?.navigationType === "INTERNAL_GROUP") {
      return "Page Group";
    }
    return "Page";
  };

  return (
    <>
      {reload && <Loading />}
      <DynamicTable
        rows={pages}
        columns={columns}
        searchText={searchText}
        onRowClick={(row) => {
          toggleRowExpansion(row.id);
        }}
        onRowOrderChange={(newOrder) => {
          handleRowOrder(newOrder);
        }}
        expandedRow={expandedRow}
        renderActions={(row, col) => renderActions(row, col)}
        pagination={false}
        renderChildComponent={renderChild}
        enableDragAndDrop={true}
        loading={loading}
        cellRenderer={cellRenderer}
      />
    </>
  );
};

export default PageTable;
